import { redirect, useParams } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import {
  RelocationRecord,
  relocationRecordQuery,
} from "@/app/Relocations/GraphQL/relocationRecordQuery";

export function useRelocationRecord(): RelocationRecord {
  const { relocationId } = useParams({ strict: false });

  if (!relocationId) {
    throw new Error("useRelocationRecord used outside a relocation route");
  }

  const { data } = useSuspenseGqlQuery(relocationRecordQuery, {
    id: relocationId,
  });

  if (data.relocation === null || data.relocation === undefined) {
    throw redirect({
      from: "/$tenant/$orgId/supplier/{-$supplierId}",
      to: "/$tenant/$orgId/supplier/{-$supplierId}/relocations/not-found",
      params: (prev) => prev,
    });
  }

  return data.relocation;
}
